var React = require('react');

function ArrowUpInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 4.411V16H7V4.417l-4.33 4.33-1.415-1.414 6.04-6.04a1 1 0 0 1 1.415 0l6.04 6.04-1.414 1.415L9 4.41z","fill":"currentColor"}));
}

ArrowUpInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = ArrowUpInline;

ArrowUpInline.default = ArrowUpInline;
